export const FETCH_CONSULTS_REQUEST = "FETCH_CONSULTS_REQUEST";
